import Button from "components/v2/Button/Button";
import { ReactComponent as PlusIcon } from "assets/images/iconsV2/plus.svg";

type AddRowButtonProps = {
  label: string;
  onClick: () => void;
  testId?: string;
  disabled?: boolean;
};

export default function AddRowButton({ label, onClick, testId, disabled = false }: AddRowButtonProps) {
  return (
    <div data-testid={testId}>
      <Button variant="link-color" onClick={onClick} iconLeft={<PlusIcon />} label={label} disabled={disabled} />
    </div>
  );
}
